// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* On screens that are 600px or less, set the background color to olive */\n@media screen and (max-width: 480px) {\n  .MuiStepLabel-root {\n    padding-top: 10px; }\n  .makeStyles-root-2 {\n    width: 25px !important;\n    height: 25px !important; } }\n", ""]);
// Exports
module.exports = exports;
